import React, { Fragment, useState } from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import { Navigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCirclePlus, faTrash, faEdit } from '@fortawesome/free-solid-svg-icons'
import '../../../styles/diario.scss';


function HomeLoggedCargosScreen() {
    const [cad, setCad] = useState(false)
    const [editar, setEditar] = useState(false)
    const [apagar, setApagar] = useState(false)
    if (editar) {
        return <Navigate to={{ pathname: '/rh/holerites/editar' }} />
    }

    if (apagar) {
        return <Navigate to={{ pathname: '/rh/holerites/apagar' }} />
    }

    if (cad) {
        return <Navigate to={{ pathname: '/rh/holerites/cadastrar' }} />
    }

    return (
        <Fragment>
            <Container>
                <Row xs={1} lg={2}>
                    <Col>
                        <Card className='card-list' onClick={e => setCad(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={2}>
                                                <FontAwesomeIcon className='icon-cad' icon={faFileCirclePlus} />
                                            </Col>
                                            <Col xs={10}>
                                                <p className='titulo-lei'>Cadastrar Holerite do Mês Vigente</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='card-list' onClick={e => setEditar(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={2}>
                                                <FontAwesomeIcon className='icon-cad' icon={faEdit} />
                                            </Col>
                                            <Col xs={10}>
                                                <p className='titulo-lei'>Editar holerite</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='card-list' onClick={e => setApagar(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={2}>
                                                <FontAwesomeIcon className='icon-cad' icon={faTrash} />
                                            </Col>
                                            <Col xs={10}>
                                                <p className='titulo-lei'>Apagar Holerites/Mês</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                    <Fragment>
                        <br /><br />
                        <Link to={'/rh'}>
                            <Button variant="danger" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Fragment>
            </Container>
        </Fragment>
    );
}

export default HomeLoggedCargosScreen;